<div class="classification-area container"
  id="zipcodeContainer"
  #containerRef>
  <div class="row"
    [style.minHeight.px]="rowHeight"
    [appHighlight]="highlightColor"
    [defaultColor]="defaultColor"
    (color)="handleMouseEvent( $event)">
    <div class="question"
      [ngClass]="cssClass">
      @if (questionNo) {
        <label class="question-no">{{questionNo}}</label>
      }
      <p class="title-area">{{question}}</p>
    </div>
    <div class="zipcode-container"
      [ngClass]="componentClass">
      <form action="" [formGroup]="ZipcodeForm">
        <div class="start-quote-section-address">
          <div class="start-quote-section-address-zipcode"
            #anchorRef>
            <!-- crux-zipcode (library) calls the lookup API on every keystroke due to a bug in its
            onZipChange guard (compares the raw value/event numerically against 5 instead of
            checking string length), so app-csb-core-zipcode is used instead - it only calls
            the API once the input reaches 5 digits (or is cleared). -->
            <app-csb-core-zipcode
              type="'tel'"
              [autoComplete]="'off'"
              [label]="placeHolder"
              showErrors="false"
              [api]="locationService.zipServiceUrl"
              postalCodeParam="$search-term$"
              [zipCodeFormControl]="zipCodeFormControl"
              [zipCodeValue$]="zipCodeValue$"
              ngDefaultControl
              appearance="chubb"
            ></app-csb-core-zipcode>

            @if (checkDirtyAndEmpty()) {
              <p class="help-block">
                <span class="bgcircle">i</span>
                {{ errorText }}
              </p>
            }
            @if (notMatcherror) {
              <p class="help-block">
                <span class="bgcircle">i</span>
                {{ errorMessages.zipcode.noMatch }}
              </p>
            }
          </div>
          <!-- <div *ngIf="cityList && cityList?.length <= 1 && isValidZipCode"
          [ngClass]="isValidZipCode && (cityList?.length === 1 || cityList?.length === 0) ? 'start-quote-section-address--border-bottom' : 'noShow'">
          <span *ngIf="isValidZipCode && (cityList?.length === 1 || cityList?.length === 0)"> {{zipcodeData[0].City | titlecase}} </span>
        </div> -->
        <!-- *ngIf="cityList?.length > 1 && isValidZipCode && focusIn"
        [style.marginTop.px]="alignTop"
        [style.marginBottom.px]="alignBottom"
        [style.left.px]="leftSpace" -->
        <div class="start-quote-section-address-city">
          <div class="start-quote-section-address-city--details">
            @if (cityList && cityList.length === 1) {
              <div cbInput
                class="start-quote-section-address-city--details-cityinfo"
                label="City"
                hideRequiredMarker="true">
                <input type="text" required="true" [formControl]="city" autocomplete="off" />
              </div>
            }
            @if ((cityList && cityList.length > 1)) {
              <div [cbSelectChoice]="citySelect"
                class="start-quote-section-address-city--details-cityinfo"
                [label]="placeHolderSubText"
                styleVariant="gray-fill">
                <p-select #citySelect
                  [formControl]="city"
                  [options]="cityList"
                  optionLabel="value"
                  optionValue="value"
                  placeholder="Select..."
                  inputId="citySelect"
                  appendTo="body"
                  (onChange)="setMulticityData($event.value)">
                </p-select>
              </div>
            }
            @if (city.value && state.value) {
              <div cbInput
                class="start-quote-section-address-city--details-state"
                label="State"
                hideRequiredMarker="true">
                <input type="text" required="true" [formControl]="state" autocomplete="off" />
              </div>
            }
          </div>
        </div>
        <!-- <div [ngClass]="isValidZipCode && isCitySelected ? 'start-quote-section-address-state' : 'hiddenState'">
        <span *ngIf="isValidZipCode && isCitySelected && zipcodeData.length === 1">{{ zipcodeData[0].StateProvince }}</span>
      </div> -->
    </div>
  </form>
</div>
</div>
</div>

